import { Tab, Tabs } from "@blueprintjs/core"
import React, { useState } from "react"
import Parameter from "./Parameter"
import { get } from "lodash-es"
import { withFormController } from "components/Molecules/FormController"
import CustomButton from "components/Atoms/CustomButton"
import {
  Download,
  DownloadSimple,
  PlusCircle,
  XCircle,
} from "@phosphor-icons/react"
const PARAMETERS = [
  {
    id: "PHYS",
    title: "Physical",
  },
  {
    id: "CHEM",
    title: "Chemical",
  },
  {
    id: "BIOL",
    title: "Biological",
  },
  {
    id: "MCRO",
    title: "Microbial",
  },
  {
    id: "HVYM",
    title: "Heavy Metal",
  },
]
const Parameters = ({ source, path }) => {
  const [selectedTabId, changeSelected] = useState("PHYS")
  const qualityParameters = get(source, path, [])
  return (
    <>
      <div className="flex justify-between items-center">
        <h6 className="mt-6 vt-section-header">Parameters</h6>
        <div className="flex gap-3">
          <CustomButton text={"Send for Approval"}></CustomButton>
          <CustomButton
            text={"Download"}
            icon={<DownloadSimple weight="fill" size={20} />}
          ></CustomButton>
          <CustomButton
            intent="primary"
            text={"Parameter"}
            icon={<PlusCircle size={20} />}
          ></CustomButton>
        </div>
      </div>
      <hr className="mt-0" />
      {/* <Tabs
        large={true}
        selectedTabId={selectedTabId}
        className="vt-custom-tabs"
        onChange={tab => changeSelected(tab as string)}
      >
        {PARAMETERS.map(({ id, title }) => (
          <Tab
            key={id}
            id={id}
            title={title}
            panel={
              <Parameter
                path="qualityParameters"
                parameterType={id}
                data={qualityParameters
                  .map((param, index) => ({ ...param, uuid: index }))
                  .filter(params => params.parameterType === id)}

              ></Parameter>
            }
          ></Tab>
        ))}

        <Tabs.Expander />
      </Tabs> */}
      <div></div>
    </>
  )
}

export default withFormController(Parameters)
